<template>
  <div style="over-flow:hidden;overflow-x: hidden;margin:0 auto">
    <div>

      <div class="parkserve">

        <div class="parkservetext">

          <h6 class="animated fadeInDown">智慧停车场</h6>

          <p
            class="animated fadeInUp"
            style="color:#FFFFFF;margin:0 auto"
          >互联网+停车场</p>
          <a
            target="_blank"
            href="http://www.yzparking.cn:8000"
            class="animated fadeInDown"
          >登录</a>
        </div>
      </div>

      <div style="margin-bottom:100px">
        <el-row>
          <el-col :span="24">
            <ul>
              <li
                style
                class="animated fadeInLeft"
              >
                <div style=" border-right: 2px solid rgb(221, 220, 220);padding-top:0px">
                  <div class="icon">
                    <i class="icon iconfont icon-chezhuxinxi"></i>
                  </div>

                  <div class="item itemone">
                    <div class="detaile list">


                      <div class="timeline">
                        <h4>多种服务集成</h4>
                        <p>停车场经营者通过“云智停车信息平台”实现集停车、充电、汽车服务等为一体的经营管理功能。</p>
                      </div>
                    </div>
                    <div></div>
                  </div>
                </div>
              </li>
              <li class="animated fadeInRight">
                <div class="rightitem">
                  <div class="itemtwo">
                    <div
                      class="righticon"
                      style="float:left"
                    >
                      <i class="icon iconfont icon-chezhuxinxi"></i>
                    </div>
                    <div class="detaile list">


                      <div class="timeline">
                        <h4>规范资金管理</h4>
                        <p>降低现金清点、票证管理难度，过严格的信息管理，防止跑冒滴漏</p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li
                style="padding-top:120px"
                class="animated fadeInLeft"
              >
                <div style=" border-right: 2px solid rgb(221, 220, 220);">
                  <div class="icon">
                    <i class="icon iconfont icon-chezhuxinxi"></i>
                  </div>

                  <div
                    class="item itemone"
                    style="    color: #fff;
    background-color: #f96868;
    border-color: #f96868;"
                  >
                    <div class="detaile list">


                      <div class="timeline">
                        <h4>提升车场竞争力</h4>
                        <p>通过智能诱导系统，为停车场导流，提升停车场服务质量。</p>
                      </div>
                    </div>
                    <div></div>
                  </div>
                </div>
              </li>
              <li class="animated fadeInRight">
                <div style="float:right;border-left: 2px solid rgb(221, 220, 220);margin:-2px;">
                  <div
                    class="itemtwo"
                    style="background-color: #46be8a;
    border-color: #46be8a;"
                  >
                    <div
                      class="righticon"
                      style="float:left"
                    >
                      <i class="icon iconfont icon-chezhuxinxi"></i>
                    </div>
                    <div class="detaile list">


                      <div class="timeline">
                        <h4>方便、快捷 </h4>
                        <p>用无感支付减少收费人员，最终实现无人值守。</p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li
                style="margin-top:120px"
                class="animated fadeInLeft"
              >
                <div style=" border-right: 2px solid rgb(221, 220, 220);">
                  <div class="icon">
                    <i class="icon iconfont icon-chezhuxinxi"></i>
                  </div>

                  <div class="item itemone">
                    <div class="detaile list">


                      <div class="timeline">
                        <h4>免费稳定</h4>
                        <p>平台接入云端免费升级。</p>
                      </div>
                    </div>
                    <div></div>
                  </div>
                </div>
              </li>
              <li class="animated fadeInRight">
                <div class="rightitem">
                  <div>
                    <div class="itemtwo">
                      <div
                        class="righticon"
                        style="float:left"
                      >
                        <i class="icon iconfont icon-chezhuxinxi"></i>
                      </div>
                      <div class="detaile list">


                        <div class="timeline">
                          <h4>互联网+停车场</h4>
                          <p>大幅降低停车场经营成本，扩大停车场的盈利模式和盈利能力。</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>
    </div>
    <img
      style="width:100%"
      src="../assets/img/jionus.png"
      alt=""
    >
  </div>
</template>
<script>
export default {
  name: 'parkservice',
  data() {
    return {};
  },
};
</script>

<style scoped>
.parkservetext {
  /* padding-top: 100px; */
}
.parkservetext h6 {
  font-size: 30px;
  letter-spacing: 2px;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: normal;
}
.parkservetext p {
  letter-spacing: 3px;
  padding: 20px;

  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  font-weight: normal;
}
.parkservetext a {
  width: 120px;
  margin-bottom: 70px;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-color: #dcdfe6;
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  padding: 12px 20px;

  font-size: 18px;
  border-radius: 25px;
  margin-bottom: 70px;
}
.content {
  width: 1000px;
  margin: 0 auto;
  font-size: 20px;
  text-align: center;
  font-weight: normal;
  color: #030303;
}
.content p {
  font-size: 15px;
  line-height: 30px;
}

.parkserve {
  color: #ffffff;
  text-align: center;
}
.parkserve::before {
  background-size: 100% 100%;
  width: 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 400px;
  content: '';
  position: absolute;
  top: 100px;
  right: 0;
  bottom: 100px;
  left: 0;
  background-image: url('../assets/img/checahng.jpg');
  -webkit-filter: blur(3px);
  -moz-filter: blur(3px);
  -ms-filter: blur(3px);
  -o-filter: blur(3px);
  filter: blur(3px);
  filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius=4, MakeShadow=false);
}
.parkserve button {
  color: #ffffff;
}
.rightitem {
  float: right;
  border-left: 2px solid rgb(221, 220, 220);
  margin: -2px;
}
li > div {
  width: 50%;
  padding-right: 0px;
  padding-top: 50px;
  height: 100px;
}
.item {
  border-radius: 10px;
  width: 80%;
  height: 100px;
  color: #fff;
}
.itemone {
  border-radius: 10px;
  width: 80%;
  height: 100px;
  color: #fff;
  background-color: #57c7d4;
  font-size: 18px;
  float: right;
  border-color: #57c7d4;
  text-align: left;
}
.itemtwo {
  width: 80%;
  padding-top: 10px;
  height: 100px;
  color: #fff;
  background-color: #62a8ea;
  border-color: #62a8ea;

  text-align: left;
  border-radius: 8px;
  margin-left: 30px;
}
/* li .itemtwo {
    float: right;
} */

.detaile {
  padding-left: 20px;
  margin-top: 15px;
  /* display: flex;
    justify-content: space-around; */
}
.detaile div {
  float: left;
}
i {
  padding: 10px;
  border-radius: 100%;
  color: #ffffff;
}

.icon i {
  background-color: #57c7d4;

  float: right;
  position: relative;
  top: 30px;
  left: 20px;
}
.righticon i {
  background-color: #57c7d4;

  float: right;
  position: relative;
  top: 30px;
  right: 50px;
}
.timeline p,
.timeline h4 {
  padding-left: 15px;
}
.timeline p {
  padding-top: 5px;
}
.number {
  height: 40px;
  width: 40px !important;
  text-align: center;
  border-radius: 1000px;
  background: #fff;
  line-height: 40px;
  color: #57c7d4;
  padding: none;
}
</style>



// WEBPACK FOOTER //
// src/components/parkservice.vue